export class EnrollInterviewInfo {
  protocol_number: number = null;
  protocol_date: Date;
  interview_result_mark: number = null;
  interviewSpecialExamType: number = null;
  interviewSpecialExam: number = null;
  protocol_copy_scan: any;
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/edu-info/enroll-interview-info.ts